import BasicRouterView from "../../components/BasicRouterView.vue";

const agenteVendasRoutes = {
  path: "agente-vendas",
  redirect: { name: "agente-vendas.selecionar-maquina" },
  meta: {
    label: "Agente de Vendas",
    icon: "precision_manufacturing",
    show: true,
    tabsShow: false,
    permissioOnly: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "selecionar-maquina",
      name: "agente-vendas.selecionar-maquina",
      meta: {
        label: "Seleção de Máquinas",
        icon: "precision_manufacturing",
        show: true,
        breadcrumb: true,
        permissioOnly: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "agente-vendas" */ "./views/AgenteVendas.vue"
        ),
    },
  ],
};

export default agenteVendasRoutes;
